/**
 * Alias tokens. Each value is a brand primitive.
 * Background and divider match the Neutrals they repeat in Figma.
 * Text Strings repeats the Space scale, then references the extra steps.
 */

import { brandColors, brandSpace } from './brand';

export const aliasColors = {
  background: {
    bg01: brandColors.neutrals.baseWhite,
    bg02: brandColors.neutrals.grey100,
    bg03: brandColors.neutrals.grey200,
    bg04: brandColors.neutrals.grey300,
  },
  divider: {
    divider01: brandColors.neutrals.grey100,
    divider02: brandColors.neutrals.grey200,
    divider03: brandColors.neutrals.grey300,
    divider04: brandColors.neutrals.grey400,
  },
};

export const aliasSpace = {
  none: brandSpace.none,
  xxs: brandSpace.xxs,
  xs: brandSpace.xs,
  s: brandSpace.s,
  m: brandSpace.m,
  l: brandSpace.l,
  xl: brandSpace.xl,
  xxl: brandSpace.xxl,
  xxxl: brandSpace.xxxl,
  xl4: brandSpace.xl4,
  xl5: brandSpace.xl5,
};

export const aliasTextStrings = {
  none: aliasSpace.none,
  xxs: aliasSpace.xxs,
  xs: aliasSpace.xs,
  s: aliasSpace.s,
  m: aliasSpace.m,
  l: aliasSpace.l,
  xl: aliasSpace.xl,
  xxl: aliasSpace.xxl,
  xxxl: aliasSpace.xxxl,
  xl4: aliasSpace.xl4,
  xl5: aliasSpace.xl5,
  smallGaps: brandSpace.smallGaps,
  gaps: brandSpace.gaps,
  largeGaps: brandSpace.largeGaps,
  curve: brandSpace.curve,
};
